var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","height":"100","outlined":"","color":"grey lighten-1"},on:{"click":_vm.createNewContextHandler}},[_vm._v("\n  Create New\n")])}
var staticRenderFns = []

export { render, staticRenderFns }